export default __webpack_public_path__ + "static/logo15-5a1dac820b4370f9bd9332d7ab92f531.png";